import { ReactNode } from 'react';

export enum ErrorVariant {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type ErrorProps = {
  title: string;
  variant: ErrorVariant;
  subtitle?: string | null;
  children?: ReactNode;
};
